<template>
  <div class="user-profile-link">
    <router-link
      :title="user.screen_name_full_ui"
      :to="userProfileLink(user)"
    >
      <slot>
        <span class="user-link-name">{{ at ? '@' : '' }}{{ handleName }}</span><span
          v-if="handleServer"
          class="user-link-server"
        >@{{ handleServer }}</span><UnicodeDomainIndicator
          :user="user"
        />
      </slot>
    </router-link>
  </div>
</template>

<script>
import UnicodeDomainIndicator from 'src/components/unicode_domain_indicator/unicode_domain_indicator.vue'

import { profileLink } from 'src/services/user_display/user_display.js'

const UserLink = {
  props: {
    user: Object,
    at: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    UnicodeDomainIndicator,
  },
  computed: {
    // the handle in two parts: on a narrow line the name part gives way
    // first, so the server stays readable
    handleParts() {
      const handle = this.user.screen_name_ui ?? ''
      const at = handle.indexOf('@', 1)
      return at === -1
        ? [handle, '']
        : [handle.slice(0, at), handle.slice(at + 1)]
    },
    handleName() {
      return this.handleParts[0]
    },
    handleServer() {
      return this.handleParts[1]
    },
  },
  methods: {
    userProfileLink: profileLink,
  },
}

export default UserLink
</script>

<style lang="scss">
/* a handle always takes one line: the name part shrinks ("…"), the server
   stays whole unless it alone is too long; the full handle is the title */
.user-profile-link {
  min-width: 0;
  max-width: 100%;

  > a {
    display: inline-flex;
    max-width: 100%;
    min-width: 0;
    white-space: nowrap;
    vertical-align: bottom;
  }

  .user-link-name,
  .user-link-server {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .user-link-name {
    flex: 0 1 auto;
    min-width: 0;
  }

  /* the server shrinks only when it alone is longer than the line */
  .user-link-server {
    flex: 0 0 auto;
    max-width: 100%;
  }
}
</style>
